import type { NavigateFunction } from "react-router-dom";

export const ONLINE_DEVICE_SETUP_PATH = "/device-setup";
export const OFFLINE_DEVICE_SETUP_URL = "https://www.oculera.health/device-setup";

export function isOfflineFrontendMode(): boolean {
  return process.env.REACT_APP_OFFLINE === "true" || process.env.REACT_APP_MODE === "OFFLINE";
}

export function openDeviceSetupPage(navigate: NavigateFunction): void {
  if (isOfflineFrontendMode()) {
    window.location.assign(OFFLINE_DEVICE_SETUP_URL);
    return;
  }

  navigate(ONLINE_DEVICE_SETUP_PATH);
}
